import { type FC } from 'react';
import cn from 'classnames';

import { H3 } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

interface GuaranteedRewardProps {
  id: string;
  picture: {
    alt: string;
    img: string;
    webp?: string;
  };
  className?: string;
  title: {
    text: string;
    className?: string;
  };
  description: {
    text: string;
    className?: string;
  };
}

const GuaranteedReward: FC<GuaranteedRewardProps> = ({
  picture,
  className,
  title,
  description,
}) => {
  return (
    <div className={cn('flex items-center gap-[4px]', className)}>
      <Picture {...picture} className="aspect-square w-[48px]" />
      <div className="flex flex-col gap-[2px]">
        <H3
          weight="bold"
          className={cn(title.className, '!leading-none !text-[18px]')}
        >
          {title.text}
        </H3>
        <span
          className={cn(
            'text-[10px] text-white/60 leading-none max-w-[45px]',
            description.className,
          )}
        >
          {description.text}
        </span>
      </div>
    </div>
  );
};

export { GuaranteedReward, type GuaranteedRewardProps };
